<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-09 15:46:27
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftList\ShiftList.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-07 15:39:11
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_shift_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-shift')"
    @new="toNew"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
    :exportBtn="hasBtn('export-admin-shift')"
    :importBtn="hasBtn('import-admin-shift')"
    :import-options="{
      api: '/shift/import/',
      templateUrl:
        'https://assets.essencehr.io/web/ess-business/assets/shift-import-template.xlsx',
      success: (result) => {
        getList(null, 1, $tableSetting.perPageSize, () => {
          $store.dispatch('resetTable', new Date().getTime());
        });
      },
    }"
    @export="onExport"
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :totalCount="totalCount"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :sortBy="['startTime']"
        :filter-page-data="filterPageData"
        :showSelect="showSelect"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <!-- 筛选 -->
        <template v-slot:top-selection> </template>
        <!-- 筛选 -->
        <template v-slot:item.color="{ item }">
          <div style="max-width: 20px">
            <svg-icon
              size="24"
              :fill="item.color_code"
              iconClass="LabeledColour"
            />
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.shift_name)"
          >
            {{ $getCommonLangValue(item.shift_name) }}
          </div>
          <div class="table-subtitle text--secondary">
            {{ $getCommonLangValue(item.shift_description) }}
          </div>
        </template>
        <template v-slot:item.abbr="{ item }">
          <div class="text--primary table-title">{{ item.shift_abbr }}</div>
        </template>
        <template v-slot:item.code="{ item }">
          <div class="text--primary table-title">{{ item.shift_code }}</div>
        </template>
        <template v-slot:item.startTime="{ item }">
          <div class="text--primary table-title">
            {{ $timeMachine(item.start_utc_time) }}
            <!-- <template
              >({{ $getUtcByCode(item.start_time_time_zone) }})</template
            > -->
          </div>
        </template>

        <template v-slot:item.endTime="{ item }">
          <div class="text--primary table-title">
            {{ $timeMachine(item.end_utc_time) }}
            <!-- ({{
              $getUtcByCode(item.end_time_time_zone)
            }}) -->
          </div>
        </template>
        <template v-slot:item.count="{ item }">
          <div class="text--primary table-title">
            {{ item.total_working_minutes
            }}{{ $t("label_essweb_system_minutesLabel") }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-shift')"
            :viewBtn="hasBtn('view-admin-shift')"
            :editBtn="hasBtn('edit-admin-shift')"
            :title="$t('label_essweb_shift_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "shiftList",
  computed: {},
  created() {},
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  data() {
    return {
      search: "",
      showSelect: false,
      selected: [],
      totalCount: 0,
      page: 1,
      headers: [
        {
          text: "label_essweb_list_components_tools_colorLabel",
          value: "color",
          align: "start",
          mrcSelected: false,
          width: 48,
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_shiftNameLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.shift_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_ClaimReason_form_codeLabel",
          value: "code",
          mrcSelected: false,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_shiftAbbrLabel",
          value: "abbr",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_StartTimeSlotLabel",
          value: "startTime",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_EndTimeSlotLabel",
          value: "endTime",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_totalMinutesLabel",
          value: "count",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_shiftActionsLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label: "label_essweb_shift_list_shiftNameLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "string",
          sequence: 1,
          name: "code",
          position: "right",
          label: "label_essweb_ClaimReason_form_codeLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "string",
          sequence: 2,
          name: "abbr",
          position: "right",
          label: "label_essweb_shift_list_shiftAbbrLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
      filterPageData: null,
    };
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["shift_name"] = item.value;
        }
        if (item["name"] == "code") {
          data["shift_code"] = item.value;
        }
        if (item["name"] == "abbr") {
          data["shift_abbr"] = item.value;
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/get-shift-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        res.data.forEach(function (item) {
          if (item.shift_type_uuid.indexOf(",") != -1) {
            item.shift_type_uuid = item.shift_type_uuid.split(",");
          } else {
            item.shift_type_uuid = [item.shift_type_uuid];
          }
          if (item.shift_property_group_uuid.indexOf(",") != -1) {
            item.shift_property_group_uuid =
              item.shift_property_group_uuid.split(",");
          } else {
            item.shift_property_group_uuid = [item.shift_property_group_uuid];
          }
        });
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/shift/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit" ? "/admin/shift/edit/" : "/admin/shift/detail/") +
          uuid
      );
    },
    onExport() {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["shift_name"] = item.value;
        }
        if (item["name"] == "code") {
          data["shift_code"] = item.value;
        }
        if (item["name"] == "abbr") {
          data["shift_abbr"] = item.value;
        }
      });
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/export/",
        data: data,
        type: "export",
        export_title: this.$t("label_essweb_shift_list_title"),
      });
    },
    toDelete: function (id) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/delete-shift-table/",
        data: { uuids: id.toString() },
      }).then((res) => {
        that.$showMessage({
          text: that.$t("message_essweb_shift_form_deleteShiftSuccessLabel"),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== id);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
